export const CUSTOMER_PERMISSIONS = {
  LIST: 'customer-list',
  CREATE: 'customer-create',
  VIEW: 'customer-view',
  EDIT: 'customer-edit',
  DELETE: 'customer-delete',
};

export const CUSTOMER_LIST_ACCESS = [
  CUSTOMER_PERMISSIONS.LIST,
  CUSTOMER_PERMISSIONS.CREATE,
  CUSTOMER_PERMISSIONS.VIEW,
  CUSTOMER_PERMISSIONS.EDIT,
  CUSTOMER_PERMISSIONS.DELETE,
];

export const CUSTOMER_VIEW_ACCESS = [
  CUSTOMER_PERMISSIONS.VIEW,
  CUSTOMER_PERMISSIONS.LIST,
  CUSTOMER_PERMISSIONS.EDIT,
];
